module.exports = __webpack_public_path__ + "img/antes_despues_245.ee956d1f.png";